import React from 'react';
import Link from 'next/link';
import Cookies from 'js-cookie';
import { useSearchParams } from 'next/navigation';
import { forwardRef } from 'react';
import { restaurant } from '@/lib/utils/routeLinks';

import { cn } from '@/lib/utils';

interface Props {
  label: string;
  icon: React.ReactNode;
  path: string;
  close: () => void;
}

export default forwardRef(function HeaderProfileButtonRes(
  { label, icon, path, close }: Props,
  ref: React.Ref<HTMLAnchorElement>
) {
  return (
    <Link
      href={{
        pathname: `${restaurant.dashboard.de()}/${path}`,
      }}
      ref={ref}
      className={cn(
        'relative flex h-[35px] w-full items-center rounded-[30px] text-paragraph transition delay-200'
      )}
      onClick={() => close()}
    >
      <span
        className={cn(
          'relative z-10 me-[15px] pl-[10px] text-neutral-400 transition delay-100'
        )}
      >
        {icon}
      </span>
      <span className={cn('relative z-10 transition delay-100')}>{label}</span>
    </Link>
  );
});
